import { Component, OnInit } from '@angular/core';
import {HttpClient} from '@angular/common/http';
import { environment } from '../../../../../../environments/environment';
import { HistoryChangeItem } from '../../../models/history-change-item';
import { LoggingService } from '../../../../../services/logging.service';

const apiServer = environment.apiServer;

@Component({
  selector: 'app-other-kp-modal-history-change',
  templateUrl: './modal-history-change.component.html',
  styleUrls: ['./modal-history-change.component.sass']
})
export class ModalOtherKpHistoryChangeComponent implements OnInit {
  http: HttpClient;

  dataHistoryChange: Array<HistoryChangeItem>;
  
  constructor(private _http: HttpClient, private loggingService: LoggingService) {
    this.http = _http;
  }

  ngOnInit() {
    $('#modalHistoryChangeComponent').off('show.bs.modal shown.bs.modal hidden.bs.modal')
      .on('show.bs.modal', function () {
        $('#modalAuctionDetail').css('z-index', 1030);
        $('#modalOtherKpDetail').css('z-index', 1040);
      })
      .on('shown.bs.modal', function () {
        $('#modalHistoryChangeComponent').css('z-index', 1070);
        $('.modal-backdrop:last').css('z-index', 1065);
      })
      .on('hidden.bs.modal', function () {
        $('#modalAuctionDetail').css('z-index', 1041);
        $('#modalOtherKpDetail').css('z-index', 1060);
      });
  }

  
  public loadHistoryChange(IDAuction){
    const _xid = this.loggingService.generateUUID();
    this.loggingService.logStart(_xid, 'App.Components.ModalOtherKpHistoryChangeComponent.loadHistoryChange', null, 'Load history change started');
    
    this.dataHistoryChange = new Array<HistoryChangeItem>();

    this.http.get<Array<string>>(apiServer + "/otherKp/changeHistory/" + IDAuction)
    .subscribe(resp => { 
      for (let index = 0; index < resp.length; index++) {
        this.dataHistoryChange[index] = { number: resp[index]['number'], action:resp[index]['action'], autor:resp[index]['autor'], date:resp[index]['date'] }; 
      }
      this.loggingService.logFinish(_xid, 'App.Components.ModalOtherKpHistoryChangeComponent.loadHistoryChange', null, 'Load history change completed');
    }, error => {
      this.loggingService.logError(_xid, 'App.Components.ModalOtherKpHistoryChangeComponent.loadHistoryChange', error, null, 'Load history change failed');
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/modules/other-kp/component/other-kp-detail/modal-history-change/modal-history-change.component.ts